import React from 'react'

import { SizeGuideFits, SizeGuideItem } from '@Domains/Cart/Components/Prompt/types'

type SizeGuideFitsContextType = {
  fits: SizeGuideFits[]
  items: SizeGuideItem[]
  onChangeSize: () => void
}

export const SizeGuideFitsContext = React.createContext<SizeGuideFitsContextType>({
  fits: [],
  items: [],
  onChangeSize: () => {},
})
